// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/down.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settingsMenuList {
    /* min-height: calc(100vh - 343px); */
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 30px 30px 0;
}

.settingsMenuList .pageSearchInput {
    width: 100%;
    margin-top: 0;
}

.settingsMenuList #pages_search {
    position: relative;
    right: 0;
}

.settingsListWrap {
    display: flex;
    margin-bottom: 30px;
}

.navLeftList {
    max-width: 370px;
    min-width: 370px;
}

.settingsMenuBlockTitle {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    color: var(--cloudburst);
}

.titleBottom {
    padding: 0 0 15px;
    margin-bottom: 0;
}

.navigationLeft {
    min-width: 280px;
    background: var(--white);
    border-width: 1px;
    border-style: solid;
    border-color: var(--ashyblue);
    border-radius: 6px;
}

.navigationBlocks {
    border-bottom: 1px solid var(--lightgrey);
    width: 100%;
}

.navigationBlocks {
    padding-top: 0px;
    padding-bottom: 0;
}

.navigationBlocks>div {
    overflow: hidden;
}

.navigationBlocks.linkAdd .customLinkRow .inputLink {
    top: 42px;
}

.pagesTitle {
    padding-right: 18px;
    padding-left: 18px;
    padding: 1rem 1.5rem;
    position: relative;
    cursor: pointer;
    margin: 0;
}

.pagesTitle::before {
    content: "";
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-position: right;
    background-repeat: no-repeat;
    width: 12px;
    height: 18px;
    display: block;
    left: auto;
    position: absolute;
    right: 20px;
    top: 20px;
    transform: rotate(270deg);
    transition: 0.3s;
}

.pagesTitle.active::before {
    transform: rotate(180deg);
}

.navigationTop {
    padding-left: 18px;
    padding-right: 18px;
    padding-bottom: 10px;
}

.navigationTop #pages_search {
    width: 100%;
    padding-left: 40px;
}

.pageSearchInput {
    width: 400px;
    position: relative;
}


.pageSearchInput img.pageSearchIcon {
    left: 15px;
    max-width: 14px;
    position: absolute;
    top: 14px;
}

.pageSearchInput input {
    width: calc(100% - 5px);
    height: 42px !important;
    background: var(--white);
    border: 1px solid var(--ashyblue);
    border-radius: 6px;
    padding: 5px 5px 6px 40px;
    outline: none;
    right: 15px;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: var(--darkblue);
}

.pageSearchInput input:not([type="checkbox"]) {
    height: 42px !important;
}

.pageSearchInput img {
    left: 15px;
    max-width: 14px;
    position: absolute;
    top: 14px;
}

.customLinkRow input::placeholder,
.menu-add-input::placeholder,
.pageSearchInput input::placeholder {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: var(--grey);
}

.settingsMenuPages {
    padding-right: 24px;
    padding-left: 24px;
    overflow: hidden;
}

.settingsMenuItem input {
    background: var(--white);
    -o-appearance: none;
    appearance: none;
    outline: none;
    content: none;
    border: none !important;
    outline: none;
    cursor: pointer;
    width: 25px;
}

.settingsMenuItem {
    display: flex;
}

.settingsMenuItem input {
    margin-top: 2px;
}

.settingsMenuItem p,
.settingsMenuItem label {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    text-align: left;
    color: var(--cloudburst);
    cursor: pointer;
}

.settingsMenuItem {
    cursor: pointer;
    margin-bottom: 10px;
}



.nothingFound {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    text-align: left;
    color: var(--cloudburst);
    margin-bottom: 10px;
}

.showMorePages {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: var(--cloudburst);
    opacity: 0.5;
    cursor: pointer;
}


.navigationBlocks {
    border-bottom: 1px solid var(--lightgrey);
    width: 100%;
}

.navigationBlocks {
    padding-top: 0px;
    padding-bottom: 0;
}

.navigationBlocks>div {
    overflow: hidden;
}

.customLinkRow input,
.menu-add-input {
    width: 100%;
    height: 40px;
    background: var(--white);
    border: 1px solid var(--ashyblue);
    border-radius: 6px;
    padding: 10px 14px;
    outline: none;
    position: relative;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: var(--darkblue);
}

.menu-add-input{
    max-width: 500px;
}

.linkInput {
    padding-left: 33px !important;
}

.navigationBlocks.linkAdd .customLinkRow input {
    padding: 10px 14px 11px 14px;
}

.customLinkRow p {
    margin-bottom: 10px;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: var(--grayishblue);
}

.customLinkRow {
    position: relative;
}

.customLinkRow {
    margin-bottom: 20px;
    padding-left: 18px;
    padding-right: 18px;
}

.navigationBlocks.linkAdd .customLinkRow .inputLink {
    top: 42px;
}

.navigationBlocks .addToMenu img {
    margin-right: 0;
    margin-left: 6px;
    max-width: 14px;
}

.inputLink {
    position: absolute;
    left: 29px;
    top: 36px;
    width: 15px;
    height: 15px;
}

.addToMenu {
    padding: 8px 10px;
    background: var(--white);
    border: 1px solid var(--ashyblue);
    box-shadow: var(--boxshadow);
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: var(--cloudburst);
    margin-left: 18px;
    margin-bottom: 18px;
}

.addToMenu img {
    margin-right: 6px;
}

.addToMenu .addMenuText {
    color: var(--cloudburst);
}

.addToMenu p {
    font-weight: 500;
    color: var(--cloudburst);
    margin: 0;
}

.navigationRight {
    margin-left: 35px;
    padding-top: 0;
    min-width: 300px;
}

.navigationRight .navItem {
    width: 380px;
}

.navRightList {
    margin-top: 15px;
}

.settingsMenuList .add-btn {
    width: max-content;
    height: 40px;
}
.settingsMenuList .add-menu-content .add-btn {
    margin-top: 10px;
}

.filter-icon {
  font-size: 16px;
  opacity: 0.7;
}

.menu-top{
    display: flex;
    gap: 10px;
}

.navItem {
    align-items: center;
    padding: 11.5px 14px;
    gap: 8px;
    background: var(--white);
    border: 1px solid var(--ashyblue);
    box-shadow: var(--boxshadow);
    border-radius: 6px;
    width: 100%;
    cursor: pointer;
    margin-bottom: 10px;
    font-size: 14px;
}

.navItem .customLinkRow {
    padding-left: 0;
    padding-right: 0;
    margin-top: 15px;
    margin-bottom: 5px;
}

.navItem {
    width: 380px;
}


.navItem .navLinkRow {
    margin-bottom: 10px;
}

.navItemLocked {
    cursor: default;
}

.navEditableVisible {
    display: flex;
    justify-content: space-between;
    -webkit-user-select: none;
            user-select: none;
}

.navEditableVisible > div {
    display: flex;
}

.navEditableVisible > div img {
    margin-right: 12px;
}

.navEditableVisible p {
    line-height: 18px;
    position: relative;
    top: 0px;
    margin: 0;
}

.navEditableVisible > div > img {
    cursor: grab;
}

.navEditableVisible .socialIcon {
    width: 18px;
}

.remove-navitem {    
    border: 0;
    background: transparent;
    padding: 0 3px;
    display: flex;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: var(--grayishblue);
    cursor: pointer;
}

.deleteRow {
    display: flex;
    align-items: center;
    margin-top: 20px;
}

.deleteRow p {
    margin-bottom: 0;
}

.deleteRow img {
    margin-right: 10px;
}

.nestable-item.is-dragging:before {
    background: var(--whitesmoke) !important;
    border: 1px dashed #d0d5dd !important;
}

@media screen and (max-width: 1260px) {
    .settingsListWrap .navLeftList {
        max-width: 100%;
        min-width: unset;
        margin-bottom: 20px;
    }

    .settingsListWrap {
        display: block;
    }

    .navLeftList .navigationLeft {
        min-width: auto;
        max-width: 100%;
    }

}


@media screen and (max-width: 1100px) {
    .navigationRight .navItem {
        width: 100%;
    }
}

@media screen and (max-width: 1024px) {

    .navigationLeft,
    .navigationRight {
        max-width: 100%;
        min-width: 100%;
    }

    .navigationRight {
        margin-left: 0px;
        padding-left: 0px;
        padding-bottom: 20px;
    }

    .navItem {
        width: 100%;
    }

    .navEditableVisible > div {
        width: 80%;
    }
}

@media screen and (max-width: 980px) {

    .pageSearchInput input {
        right: 0px;
        width: calc(100% - 20px);
    }

    .pageSearchInput img {
        position: absolute;
        left: 15px;
        top: 13px;
    }
}


@media screen and (max-width: 840px) {

    .pageSearchInput input {
        right: 0px;
    }

    .pageSearchInput img {
        left: 15px;
    }
}

@media screen and (max-width: 768px) {

    .pageSearchInput input {
        right: 0px;
    }

    .pageSearchInput img {
        left: 15px;
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/appearance.css"],"names":[],"mappings":"AAAA;IACI,qCAAqC;IACrC,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;IACxB,iBAAiB;IACjB,mBAAmB;IACnB,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,yCAAyC;IACzC,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,WAAW;IACX,yDAAyC;IACzC,0BAA0B;IAC1B,4BAA4B;IAC5B,WAAW;IACX,YAAY;IACZ,cAAc;IACd,UAAU;IACV,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;;AAGA;IACI,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;IACvB,wBAAwB;IACxB,iCAAiC;IACjC,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,SAAS;AACb;;AAEA;;;IAGI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IAGxB,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,aAAa;IACb,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;;;AAIA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,wBAAwB;IACxB,YAAY;IACZ,eAAe;AACnB;;;AAGA;IACI,yCAAyC;IACzC,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,iCAAiC;IACjC,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;IACxB,iCAAiC;IACjC,4BAA4B;IAC5B,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,wBAAwB;IACxB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;IACxB,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,gBAAgB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,QAAQ;IACR,wBAAwB;IACxB,iCAAiC;IACjC,4BAA4B;IAC5B,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;;AAGA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,SAAS;IACT,uBAAuB;IACvB,cAAc;IACd,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,wCAAwC;IACxC,qCAAqC;AACzC;;AAEA;IACI;QACI,eAAe;QACf,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,eAAe;IACnB;;AAEJ;;;AAGA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;;IAEI;;QAEI,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;QACjB,oBAAoB;IACxB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;;IAEI;QACI,UAAU;QACV,wBAAwB;IAC5B;;IAEA;QACI,kBAAkB;QAClB,UAAU;QACV,SAAS;IACb;AACJ;;;AAGA;;IAEI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;;IAEI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ","sourcesContent":[".settingsMenuList {\n    /* min-height: calc(100vh - 343px); */\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    padding: 30px 30px 0;\n}\n\n.settingsMenuList .pageSearchInput {\n    width: 100%;\n    margin-top: 0;\n}\n\n.settingsMenuList #pages_search {\n    position: relative;\n    right: 0;\n}\n\n.settingsListWrap {\n    display: flex;\n    margin-bottom: 30px;\n}\n\n.navLeftList {\n    max-width: 370px;\n    min-width: 370px;\n}\n\n.settingsMenuBlockTitle {\n    font-style: normal;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 24px;\n    color: var(--cloudburst);\n}\n\n.titleBottom {\n    padding: 0 0 15px;\n    margin-bottom: 0;\n}\n\n.navigationLeft {\n    min-width: 280px;\n    background: var(--white);\n    border-width: 1px;\n    border-style: solid;\n    border-color: var(--ashyblue);\n    border-radius: 6px;\n}\n\n.navigationBlocks {\n    border-bottom: 1px solid var(--lightgrey);\n    width: 100%;\n}\n\n.navigationBlocks {\n    padding-top: 0px;\n    padding-bottom: 0;\n}\n\n.navigationBlocks>div {\n    overflow: hidden;\n}\n\n.navigationBlocks.linkAdd .customLinkRow .inputLink {\n    top: 42px;\n}\n\n.pagesTitle {\n    padding-right: 18px;\n    padding-left: 18px;\n    padding: 1rem 1.5rem;\n    position: relative;\n    cursor: pointer;\n    margin: 0;\n}\n\n.pagesTitle::before {\n    content: \"\";\n    background-image: url(../images/down.svg);\n    background-position: right;\n    background-repeat: no-repeat;\n    width: 12px;\n    height: 18px;\n    display: block;\n    left: auto;\n    position: absolute;\n    right: 20px;\n    top: 20px;\n    transform: rotate(270deg);\n    transition: 0.3s;\n}\n\n.pagesTitle.active::before {\n    transform: rotate(180deg);\n}\n\n.navigationTop {\n    padding-left: 18px;\n    padding-right: 18px;\n    padding-bottom: 10px;\n}\n\n.navigationTop #pages_search {\n    width: 100%;\n    padding-left: 40px;\n}\n\n.pageSearchInput {\n    width: 400px;\n    position: relative;\n}\n\n\n.pageSearchInput img.pageSearchIcon {\n    left: 15px;\n    max-width: 14px;\n    position: absolute;\n    top: 14px;\n}\n\n.pageSearchInput input {\n    width: calc(100% - 5px);\n    height: 42px !important;\n    background: var(--white);\n    border: 1px solid var(--ashyblue);\n    border-radius: 6px;\n    padding: 5px 5px 6px 40px;\n    outline: none;\n    right: 15px;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 24px;\n    color: var(--darkblue);\n}\n\n.pageSearchInput input:not([type=\"checkbox\"]) {\n    height: 42px !important;\n}\n\n.pageSearchInput img {\n    left: 15px;\n    max-width: 14px;\n    position: absolute;\n    top: 14px;\n}\n\n.customLinkRow input::placeholder,\n.menu-add-input::placeholder,\n.pageSearchInput input::placeholder {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 24px;\n    color: var(--grey);\n}\n\n.settingsMenuPages {\n    padding-right: 24px;\n    padding-left: 24px;\n    overflow: hidden;\n}\n\n.settingsMenuItem input {\n    background: var(--white);\n    -moz-appearance: none;\n    -webkit-appearance: none;\n    -o-appearance: none;\n    appearance: none;\n    outline: none;\n    content: none;\n    border: none !important;\n    outline: none;\n    cursor: pointer;\n    width: 25px;\n}\n\n.settingsMenuItem {\n    display: flex;\n}\n\n.settingsMenuItem input {\n    margin-top: 2px;\n}\n\n.settingsMenuItem p,\n.settingsMenuItem label {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    text-align: left;\n    color: var(--cloudburst);\n    cursor: pointer;\n}\n\n.settingsMenuItem {\n    cursor: pointer;\n    margin-bottom: 10px;\n}\n\n\n\n.nothingFound {\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    text-align: left;\n    color: var(--cloudburst);\n    margin-bottom: 10px;\n}\n\n.showMorePages {\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    color: var(--cloudburst);\n    opacity: 0.5;\n    cursor: pointer;\n}\n\n\n.navigationBlocks {\n    border-bottom: 1px solid var(--lightgrey);\n    width: 100%;\n}\n\n.navigationBlocks {\n    padding-top: 0px;\n    padding-bottom: 0;\n}\n\n.navigationBlocks>div {\n    overflow: hidden;\n}\n\n.customLinkRow input,\n.menu-add-input {\n    width: 100%;\n    height: 40px;\n    background: var(--white);\n    border: 1px solid var(--ashyblue);\n    border-radius: 6px;\n    padding: 10px 14px;\n    outline: none;\n    position: relative;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 24px;\n    color: var(--darkblue);\n}\n\n.menu-add-input{\n    max-width: 500px;\n}\n\n.linkInput {\n    padding-left: 33px !important;\n}\n\n.navigationBlocks.linkAdd .customLinkRow input {\n    padding: 10px 14px 11px 14px;\n}\n\n.customLinkRow p {\n    margin-bottom: 10px;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    color: var(--grayishblue);\n}\n\n.customLinkRow {\n    position: relative;\n}\n\n.customLinkRow {\n    margin-bottom: 20px;\n    padding-left: 18px;\n    padding-right: 18px;\n}\n\n.navigationBlocks.linkAdd .customLinkRow .inputLink {\n    top: 42px;\n}\n\n.navigationBlocks .addToMenu img {\n    margin-right: 0;\n    margin-left: 6px;\n    max-width: 14px;\n}\n\n.inputLink {\n    position: absolute;\n    left: 29px;\n    top: 36px;\n    width: 15px;\n    height: 15px;\n}\n\n.addToMenu {\n    padding: 8px 10px;\n    background: var(--white);\n    border: 1px solid var(--ashyblue);\n    box-shadow: var(--boxshadow);\n    border-radius: 6px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    color: var(--cloudburst);\n    margin-left: 18px;\n    margin-bottom: 18px;\n}\n\n.addToMenu img {\n    margin-right: 6px;\n}\n\n.addToMenu .addMenuText {\n    color: var(--cloudburst);\n}\n\n.addToMenu p {\n    font-weight: 500;\n    color: var(--cloudburst);\n    margin: 0;\n}\n\n.navigationRight {\n    margin-left: 35px;\n    padding-top: 0;\n    min-width: 300px;\n}\n\n.navigationRight .navItem {\n    width: 380px;\n}\n\n.navRightList {\n    margin-top: 15px;\n}\n\n.settingsMenuList .add-btn {\n    width: max-content;\n    height: 40px;\n}\n.settingsMenuList .add-menu-content .add-btn {\n    margin-top: 10px;\n}\n\n.filter-icon {\n  font-size: 16px;\n  opacity: 0.7;\n}\n\n.menu-top{\n    display: flex;\n    gap: 10px;\n}\n\n.navItem {\n    align-items: center;\n    padding: 11.5px 14px;\n    gap: 8px;\n    background: var(--white);\n    border: 1px solid var(--ashyblue);\n    box-shadow: var(--boxshadow);\n    border-radius: 6px;\n    width: 100%;\n    cursor: pointer;\n    margin-bottom: 10px;\n    font-size: 14px;\n}\n\n.navItem .customLinkRow {\n    padding-left: 0;\n    padding-right: 0;\n    margin-top: 15px;\n    margin-bottom: 5px;\n}\n\n.navItem {\n    width: 380px;\n}\n\n\n.navItem .navLinkRow {\n    margin-bottom: 10px;\n}\n\n.navItemLocked {\n    cursor: default;\n}\n\n.navEditableVisible {\n    display: flex;\n    justify-content: space-between;\n    user-select: none;\n}\n\n.navEditableVisible > div {\n    display: flex;\n}\n\n.navEditableVisible > div img {\n    margin-right: 12px;\n}\n\n.navEditableVisible p {\n    line-height: 18px;\n    position: relative;\n    top: 0px;\n    margin: 0;\n}\n\n.navEditableVisible > div > img {\n    cursor: grab;\n}\n\n.navEditableVisible .socialIcon {\n    width: 18px;\n}\n\n.remove-navitem {    \n    border: 0;\n    background: transparent;\n    padding: 0 3px;\n    display: flex;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    color: var(--grayishblue);\n    cursor: pointer;\n}\n\n.deleteRow {\n    display: flex;\n    align-items: center;\n    margin-top: 20px;\n}\n\n.deleteRow p {\n    margin-bottom: 0;\n}\n\n.deleteRow img {\n    margin-right: 10px;\n}\n\n.nestable-item.is-dragging:before {\n    background: var(--whitesmoke) !important;\n    border: 1px dashed #d0d5dd !important;\n}\n\n@media screen and (max-width: 1260px) {\n    .settingsListWrap .navLeftList {\n        max-width: 100%;\n        min-width: unset;\n        margin-bottom: 20px;\n    }\n\n    .settingsListWrap {\n        display: block;\n    }\n\n    .navLeftList .navigationLeft {\n        min-width: auto;\n        max-width: 100%;\n    }\n\n}\n\n\n@media screen and (max-width: 1100px) {\n    .navigationRight .navItem {\n        width: 100%;\n    }\n}\n\n@media screen and (max-width: 1024px) {\n\n    .navigationLeft,\n    .navigationRight {\n        max-width: 100%;\n        min-width: 100%;\n    }\n\n    .navigationRight {\n        margin-left: 0px;\n        padding-left: 0px;\n        padding-bottom: 20px;\n    }\n\n    .navItem {\n        width: 100%;\n    }\n\n    .navEditableVisible > div {\n        width: 80%;\n    }\n}\n\n@media screen and (max-width: 980px) {\n\n    .pageSearchInput input {\n        right: 0px;\n        width: calc(100% - 20px);\n    }\n\n    .pageSearchInput img {\n        position: absolute;\n        left: 15px;\n        top: 13px;\n    }\n}\n\n\n@media screen and (max-width: 840px) {\n\n    .pageSearchInput input {\n        right: 0px;\n    }\n\n    .pageSearchInput img {\n        left: 15px;\n    }\n}\n\n@media screen and (max-width: 768px) {\n\n    .pageSearchInput input {\n        right: 0px;\n    }\n\n    .pageSearchInput img {\n        left: 15px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
